import DiscountItemRuleRequest from './discount-item-rule-request.entity';

export default class ContractDiscount {
  discountStrategy: string;

  discountType: string;

  periodStart: string;

  periodEnd: string;

  rules: Array<DiscountItemRuleRequest> = [];

  justificationId: string;

  observation?: string;

  constructor(obj: any = {}) {
    this.discountStrategy = obj.discountStrategy || '';
    this.discountType = obj.discountType || '';
    this.periodStart = obj.periodStart || '';
    this.periodEnd = obj.periodEnd || '';
    this.rules = obj.rules || [];
    this.justificationId = obj.justificationId || '';
    this.observation = obj.observation || '';
  }

  public static of(obj: any = {}): ContractDiscount {
    return new ContractDiscount(obj || {});
  }

  public static ofList(obj: any[]): ContractDiscount[] {
    return obj.map(this.of);
  }
}
